/**
 * wasteTrackingTypes.ts — Shared types and constants for the MobileWasteTracking wizard.
 * Extracted from MobileWasteTracking.tsx for reuse by step sub-components.
 */

export interface StationInfo {
  station_id: number;
  station_name: string;
  station_barcode?: string;
}

export interface MaterialInfo {
  item_number: string;
  item_name: string;
  transfer_number: string;
  allocated_weight: number;
  remainder_weight: number;
  item_chinese_name?: string;
  upc?: string;
  // WCO-2364: VB6 per-case deviation tolerance inputs (from ics.inventory).
  unit_weight?: number;        // full-case weight in lbs
  dev_percentage?: number;     // allowed deviation as a whole percentage (25 = ±25%)
}

export interface ScannedBox {
  id: string; // unique key for list
  barcode: string;
  weight: number;
  lot: string;
  materialName?: string;
  brand?: string;
  itemNumber?: string; // raw material item number (e.g. "B EYRN amf")
  isManual?: boolean; // true for manually added cases (not scanned)
}

export type WizardStep = 'finish_product_not_intact' | 'disposable' | 'human_error' | 'by_product' | 'remainder_not_intact' | 'intact_boxes' | 'summary' | 'supervisor_approval' | 'submitting' | 'completed';

export const STEP_ORDER: WizardStep[] = ['finish_product_not_intact', 'disposable', 'human_error', 'by_product', 'remainder_not_intact', 'intact_boxes', 'summary'];

export const STEP_LABELS: Record<string, string> = {
  finish_product_not_intact: '1',
  disposable: '2',
  human_error: '3',
  by_product: '4',
  remainder_not_intact: '5',
  intact_boxes: '6',
  summary: '7',
};
